import { AuthorizationProvider, CacheProvider, ConfigProvider, GlobalStyle } from 'common';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import App from './App';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <AuthorizationProvider>
      <CacheProvider>
        <BrowserRouter>
          <QueryParamProvider ReactRouterRoute={Route}>
            <GlobalStyle />
            <ConfigProvider typ="common">
              <App />
            </ConfigProvider>
          </QueryParamProvider>
        </BrowserRouter>
      </CacheProvider>
    </AuthorizationProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
